import React from "react";
import { BlogHeader } from "../../components/BlogHeader";
import { Developing } from "../../blocks/developing";

export const ActivityPage = () => {
  return (
    <div
      style={{
        paddingTop: 60,
      }}
    >
      <BlogHeader />
      <Developing />
    </div>
  );
};
